import { useState } from 'react';
import { Whisper, Popover } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { useCancelAppointmentMutation, useNotAttendedAppointmentMutation } from "../../State/Api/MakeAppointmentApiSlice";
import { Modal, Input } from 'antd';
import toast from 'react-hot-toast';
import { useLazyGetAppointmentDetailsByIdQuery } from '../../State/Api/AdddocApiSlice';


const ActionCellClicicAppointment = ( props ) => {
  const appointmentId = props?.data?.appointmentID;
  const status = props?.data?.appointmentStatus;
  const userClinicId = localStorage.getItem("userClinicID");
  const navigate = useNavigate();

  const [getDetails] = useLazyGetAppointmentDetailsByIdQuery();

  const handleViewDetails = async () => {
  if (appointmentId && userClinicId) {
    const result = await getDetails({ appointmentId, userClinicId });

    navigate(`/ClinicsideAppointmentDetails/${appointmentId}/${userClinicId}`, {
      state: {
        details: result.data, // optional: for immediate use
      },
    });
  }
};

  // Placeholder handlers
  const handleEdit = () => navigate(`/EditAppointment/${appointmentId}`);
  const handleReschedule = async () => {
  if (appointmentId && userClinicId) {
    try {
      const result = await getDetails({ appointmentId, userClinicId }).unwrap();

      const patientName = result?.patientFullName;
      const doctorSpecialization = result?.department;
      const doctorName = result?.doctorFullName;
      const doctorID = result?.doctorID;
      const appointmentID = result?.appointmentID;
      const patientUserUniqueID = result?.userUniqueID;


      navigate("/AddAppointment", {
  state: {
    showModal: true,
    fromRescheduleView: {
      patientName,
      doctorSpecialization,
      doctorName,
      patientUserUniqueID,
      doctorID,
      appointmentID
    },
  },
});
;
    } catch (error) {
      console.error("Failed to fetch appointment details", error);
    }
  }
};

    //Cancel Appointment

  const [ cancleApt ] = useCancelAppointmentMutation();

  const handleDelete = async (aptId, reasonToCancel) => {
    try {
      const formData = new FormData();
      formData.append("CancelReason", reasonToCancel);
      formData.append("AppointmentID", aptId);
      const result = await cancleApt(formData).unwrap();
      props.pagenumRef.current = 1;
      props?.gridRef?.current?.api?.purgeInfiniteCache();
    } catch (error) {
      // message.error("Failed to Cancel Appointment");
       
  };
}

const [notAttendedAppointment] = useNotAttendedAppointmentMutation();

const handleNotAttended = async (aptId) => {
  try {
    await notAttendedAppointment({ appointmentId: aptId }).unwrap();
    toast.success('Marked as not attended!', { position: 'top-center' });
    props.pagenumRef.current = 1;
    props?.gridRef?.current?.api?.purgeInfiniteCache();
  } catch (error) {
    toast.error('Failed to mark as not attended.', { position: 'top-center' });
    console.error("Failed to mark as not attended", error);
  }
};


const notAttendedPopup = (aptId) => {
  const NotAttendedModalContent = () => (
    <div style={{ padding: '12px 0' }}>
      {/* Warning Header with Icon */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 18 }}>
        <span style={{
          display: 'inline-block',
          background: '#FFF7E6',
          color: '#FAAD14',
          borderRadius: '50%',
          width: 40,
          height: 40,
          textAlign: 'center',
          lineHeight: '40px',
          fontSize: 22,
          fontWeight: 900,
          marginRight: 16,
        }}>
          !
        </span>
        <span style={{
          fontWeight: 600,
          fontSize: 18,
          color: '#212529'
        }}>
          Mark as Not Attended?
        </span>
      </div>
      <div style={{
        color: '#5A5A5A',
        fontSize: 15,
        marginBottom: 32,
        paddingLeft: 2,
      }}>
        This will indicate that the patient did not attend their scheduled appointment.<br/><br/>
        <span style={{ color: '#d48806'}}>
          Please confirm to proceed.
        </span>
      </div>
      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px'
      }}>
        <button
          style={{
            padding: '8px 28px',
            border: '1px solid #e1e1e1',
            borderRadius: '6px',
            background: '#fff',
            color: '#333',
            fontWeight: 500,
            fontSize: '15px',
            transition: 'background .2s',
            cursor: 'pointer'
          }}
          onClick={() => Modal.destroyAll()}
        >
          Cancel
        </button>
        <button
          style={{
            padding: '8px 28px',
            border: 'none',
            borderRadius: '6px',
            background: '#ffc53d',
            color: '#402700',
            fontWeight: 600,
            fontSize: '15px',
            boxShadow: '0 1px 6px #e5e5e5',
            transition: 'background .2s',
            cursor: 'pointer'
          }}
          onClick={() => {
            handleNotAttended(aptId);
            Modal.destroyAll();
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  );

  Modal.confirm({
    title: null,
    content: <NotAttendedModalContent />,
    footer: null,
    closable: true,
    width: 420,
    centered: true,
    icon: null
  });
};






const deletepopup = (aptId) => {
  let reasonToCancel = '';

  const CancelReasonModalContent = () => {
    const [value, setValue] = useState('');

    return (
      <div>
        {/* Warning */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 18 }}>
        <span style={{
          display: 'inline-block',
          background: '#ffece6ff',
          color: '#fa3614ff',
          borderRadius: '50%',
          width: 40,
          height: 40,
          textAlign: 'center',
          lineHeight: '40px',
          fontSize: 22,
          fontWeight: 900,
          marginRight: 16,
        }}>
          ?
        </span>
        <span style={{
          fontWeight: 600,
          fontSize: 18,
          color: '#212529'
        }}>
          Warning! This cannot be undone.
        </span>
      </div>

        {/* TextArea */}
        <div style={{ marginBottom: '30px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: '#666',
            fontSize: '14px'
          }}>
            Reason for deletion:
          </label>
          <Input.TextArea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Enter reason for deleting this file..."
            rows={3}
            style={{
              borderRadius: '4px',
              border: '1px solid #d9d9d9'
            }}
          />
        </div>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px'
        }}>
          <button
            style={{
              padding: '8px 24px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              background: '#fff',
              color: '#666',
              cursor: 'pointer',
              fontSize: '14px'
            }}
            onClick={() => Modal.destroyAll()}
          >
            CANCEL, KEEP
          </button>
          <button
            style={{
              padding: '8px 24px',
              border: 'none',
              borderRadius: '4px',
              background: '#ff4d4f',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onClick={() => {
              if (value.trim()) {
                handleDelete(aptId, value);
                Modal.destroyAll();
              } else {
                alert('Please provide a reason for deletion');
              }
            }}
          >
            YES, DELETE
          </button>
        </div>
      </div>
    );
  };

  Modal.confirm({
    title: null,
    content: <CancelReasonModalContent />,
    footer: null,
    closable: true,
    width: 500,
    centered: true,
    icon: null,
  });
};

  const handleCancelAppointment = () => console.log("Cancelled");
  const handleMarkInProgress = () => console.log("Marked as In Progress");
  const handleMarkCompleted = () => console.log("Marked as Completed");
  // const handleDelete = () => console.log("Deleted permanently");
  
const handleFollowUp = async () => {
  if (appointmentId && userClinicId) {
    try {
      const result = await getDetails({ appointmentId, userClinicId }).unwrap();

      console.log("Follow-up appointment details:", result);

      const patientName = result?.patientFullName;
      const doctorSpecialization = result?.department;
      const doctorName = result?.doctorFullName;
      const doctorID = result?.doctorID;
      const patientUserUniqueID = result?.userUniqueID;

      navigate("/AddAppointment", {
        state: {
          showModal: true,
          fromFollowUpView: {
            patientName,
            doctorSpecialization,
            doctorName,
            patientUserUniqueID,
            doctorID,
          },
        },
      });
    } catch (error) {
      console.error("Failed to fetch appointment details for follow-up", error);
    }
  }
};
  const handleViewRecords = () => navigate("/ViewReports");
  const handleGenerateInvoice = () => console.log("Invoice generated");

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-56 shadow-md border z-[999]">
      <div className="px-3 pt-2 pb-1 text-sm font-semibold text-gray-900">Actions</div>

      {/* Common: View Details */}
      <div onClick={handleViewDetails}
        className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100">View details</div>

      {status === "Completed" && (
        <>
          {/* <div onClick={handleViewRecords}
            className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100">View medical reports</div> */}
          <div onClick={handleFollowUp}
            className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100">Create follow-up</div>
          {/* <div onClick={handleGenerateInvoice}
            className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100">Generate invoice</div> */}
        </>
      )}


      {status === "Cancelled" && (
        <>
          <div onClick={handleReschedule}
            className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100">Reschedule appointment</div>
          <div onClick={handleDelete}
            className="px-3 py-2 text-sm text-red-600 cursor-pointer hover:bg-red-100 font-medium">Delete permanently</div>
        </>
      )}

    {(status === "Rescheduled" || status === "Scheduled") && (
  <>
    {/* <div onClick={handleEdit}
      className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100">Edit appointment</div> */}
    <div
      onClick={handleReschedule}
      className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100"
    >
      Reschedule
    </div>
    {/* <div onClick={handleMarkInProgress}
      className="px-3 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100 flex items-center gap-1">
      <MdDone className="text-green-500" />
      <span>Mark as in progress</span>
    </div> */}
    <div
      onClick={() => deletepopup(appointmentId)}
      className="px-3 py-2 text-sm text-red-600 cursor-pointer hover:bg-red-100 font-medium"
    >
      Cancel appointment
    </div>

    <div
      onClick={() => notAttendedPopup(appointmentId)}
      className="px-3 py-2 text-sm text-gray-600 cursor-pointer hover:bg-gray-100 font-medium"
    >
      Mark as not attended
    </div>
  </>
)}

      
    </Popover>
  );

  return (
    <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderPopover}>
      <button
        className="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="19" cy="12" r="1"></circle>
          <circle cx="5" cy="12" r="1"></circle>
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellClicicAppointment;
